import autoBind from 'react-autobind';
import {Comment} from './';
import {connect} from 'react-redux';
import Divider from 'material-ui/Divider';
import {handleApiError} from '../../shared/services';
import {List} from 'immutable';
import {loadAllComments} from '../actions';
import muiTheme from '../../../styles/teamologyTheme';
import {withRouter} from 'react-router';

import React, {Component, PropTypes} from 'react';

class CommentsList extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    const {lessonPlanId, router} = this.props;

    this.props.loadAllComments(lessonPlanId)
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to load the lesson plan comments.', 'Error'));
  }

  render() {
    const {comments} = this.props;

    const dividerStyle = {
      backgroundColor: muiTheme.palette.secondary4Color,
      marginLeft: 40,
      marginRight: 40,
    };

    return (
      <div className="community-comments-list">
        {
          comments.map(comment =>
            <div key={comment.get('id')}>
              <Comment model={comment} />
              <Divider style={dividerStyle} />
            </div>
          )
        }
      </div>
    );
  }
}

CommentsList.propTypes = {
  comments: PropTypes.instanceOf(List).isRequired,
  lessonPlanId: PropTypes.string.isRequired,
  loadAllComments: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {commentsSection} = state.features.comments.pages;

  return {
    comments: commentsSection.get('comments'),
  };
}

export default withRouter(connect(
  mapStateToProps, {
    loadAllComments,
  }
)(CommentsList));



// WEBPACK FOOTER //
// ./app/features/comments/components/CommentsList.js